const c = {
  name: "Troubleshooting",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 39.7 39.8" style="enable-background:new 0 0 39.7 39.8;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M20.7,14V8h-2v6H20.7z"/>
		<path class="st0" d="M19.7,18.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C18.5,17.7,19,18.2,19.7,18.2
			z"/>
		<path class="st0" d="M19.7,0c-7.2,0-13,5.8-13,13c0,3.2,1.2,6.2,3.1,8.5L0,31.3l1.4,1.4l9.8-9.8c0.8,0.7,1.7,1.3,2.7,1.8
			c-0.1,0.8-0.2,1.6-0.2,2.4c0,1.1,0.1,2.1,0.4,3.1l0.2,1l1-0.2c1.1-0.3,2.2,0.2,2.8,1.2c0.6,1,0.4,2.2-0.4,3L17,35.7l0.7,0.7
			c1.5,1.4,3.3,2.5,5.4,3.1l1,0.3l0.3-1c0.3-1,1.3-1.8,2.4-1.8s2.1,0.8,2.4,1.8l0.3,1l1-0.3c2-0.6,3.9-1.7,5.4-3.1l0.7-0.7L35.7,35
			c-0.7-0.8-0.9-2-0.4-3c0.6-1,1.7-1.4,2.8-1.2l1,0.2l0.2-1c0.2-1,0.4-2,0.4-3.1c0-1.1-0.1-2.1-0.4-3.1l-0.2-1l-1,0.2
			c-1.1,0.3-2.2-0.2-2.8-1.2c-0.6-1-0.4-2.2,0.4-3l0.7-0.7l-0.7-0.7c-0.9-0.9-2-1.7-3.2-2.3c0.1-0.8,0.2-1.6,0.2-2.4
			C32.7,5.8,26.9,0,19.7,0z M8.7,13c0-6.1,4.9-11,11-11s11,4.9,11,11c0,6.1-4.9,11-11,11S8.7,19.1,8.7,13z M22.4,25.7
			c-0.1,0.4-0.2,0.8-0.2,1.3c0,2.5,2,4.5,4.5,4.5s4.5-2,4.5-4.5c0-1.9-1.2-3.6-2.9-4.2c1.7-1.5,2.9-3.3,3.7-5.4
			c0.6,0.3,1.2,0.7,1.7,1.1c-0.8,1.3-0.9,3.1,0,4.5l0,0c0.8,1.5,2.4,2.3,3.9,2.2c0.1,0.6,0.1,1.2,0.1,1.8c0,0.6,0,1.2-0.1,1.8
			c-1.6,0-3.1,0.8-3.9,2.2l0,0c-0.8,1.5-0.8,3.2,0,4.5c-0.9,0.7-1.9,1.3-3,1.8c-0.8-1.4-2.2-2.3-3.9-2.3c-1.7,0-3.1,0.9-3.9,2.3
			c-1.1-0.4-2.1-1-3-1.8c0.8-1.3,0.9-3.1,0-4.5l0,0c-0.8-1.5-2.4-2.3-3.9-2.2c-0.1-0.6-0.1-1.2-0.1-1.8c0-0.5,0-1.1,0.1-1.6
			c1.2,0.4,2.5,0.6,3.9,0.6C20.6,26,21.5,25.9,22.4,25.7z M24.2,27c0-1.4,1.1-2.5,2.5-2.5c1.4,0,2.5,1.1,2.5,2.5
			c0,1.4-1.1,2.5-2.5,2.5C25.3,29.5,24.2,28.4,24.2,27z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Troubleshooting
};
